module.exports = __webpack_public_path__ + "img/new_60.550ca51e.jpg";